import { Grid } from "@mui/material"

import LineGraph from "../../../component/lineGraph/LineGraph"
import "../../../component/lineGraph/lineSensori.scss";
import TransportoForm from "./TransportoForm";
import { useSelector } from "react-redux";

const SubTrasporto = () => {
    const singleData = useSelector((state) => state.trasporto.singleTrasport);
    console.log(singleData, "singledata321")

    return (
        <>
            <div className="pageTemplate">

                <Grid container spacing={3}>
                    <Grid size={{ lg: 3, md: 4, xs: 12 }} >
                        <TransportoForm sub={true} singleData={singleData} />
                    </Grid>
                    <Grid size={{ lg: 9, md: 8, xs: 12 }}>
                        <p style={{ marginBottom: "17px", fontWeight: "400", lineHeight: "100%", marginTop: "16px" }}>Dati di viaggio</p>
                        <LineGraph subTrasporto={false} />
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default SubTrasporto
